import { Component, Input } from '@angular/core';

@Component({
  selector: 'via-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss']
})
export class InfoIconComponent {

  @Input()
  public tooltipText = '';

}
